import type { PayloadAction } from "@reduxjs/toolkit";
import { RoiQuality } from "Data/Objects/Camera";
import { createAppSlice } from "Data/Redux/Store";
import type { RoiSettingsState } from "Interfaces";
import { constant, times } from "lodash";

const initialState: RoiSettingsState = {
	roiEnabled: false,
	quality: RoiQuality.LOW,
	zones: times(8, (constant(null)))
};

export const setRoiSettingsReducer = (state: RoiSettingsState, action: PayloadAction<RoiSettingsState>) => {
	return action.payload;
};

export const getRoiSettings = (state: RoiSettingsState) => {
	return state;
};

const roiSlice = createAppSlice({
	name: "roi",
	initialState,
	reducers: {
		setRoiSettingsAction: setRoiSettingsReducer
	},
	selectors: {
		selectRoiSettings: getRoiSettings
	}
});

export default roiSlice;

export const { setRoiSettingsAction } = roiSlice.actions;
export const { selectRoiSettings } = roiSlice.selectors;
